(function ($, Drupal) {
  Drupal.behaviors.beijertechgroupSlideshow = {
    attach: function (context) {
      const $container = $('.slideshow', context),
        totalSlides = $container.find('img').length;

      let random = Math.floor(Math.random() * totalSlides);

      $container.unbind().on('beijertechgroupSlideshow').slick({
        initialSlide: random,
        autoplay: true,
        autoplaySpeed: 15000,
        dots: true,
        infinite: true,
        speed: 500,
        fade: true,
        arrows: false
      });
    }
  };
})(jQuery, Drupal);
